import {createSlice} from "@reduxjs/toolkit";

const initialDepartmentSubsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  departmentSubForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const departmentSubsSlice = createSlice({
  name: "departmentSubs",
  initialState: initialDepartmentSubsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDepartmentSubById
    departmentSubFetched: (state, action) => {
      state.actionsLoading = false;
      state.departmentSubForEdit = action.payload.departmentSubForEdit;
      state.error = null;
    },
    // findDepartmentSubs
    departmentSubsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createDepartmentSub
    departmentSubCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.departmentSub);
    },
    // updateDepartmentSub
    departmentSubUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.departmentSubId === action.payload.departmentSub.departmentSubId) {
          return action.payload.departmentSub;
        }
        return entity;
      });
    },
    // deleteDepartmentSub
    departmentSubDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.departmentSubId !== action.payload.departmentSubId);
    },
    // deleteDepartmentSubs
    departmentSubsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.departmentSubId)
      );
    },
  }
});
